import {useGetters} from './_default';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        positions: [],
        itemPositionsMap: {},
        positionsMap: {},
    },
    getters: {
        ...useGetters(),
        positions: state => state.positions,
        itemPositions(state){
            return (id) => {
                if (!state.itemPositionsMap[id] || !Array.isArray(state.itemPositionsMap[id])) return [];
                return [...state.itemPositionsMap[id]].map(id => state.positions[state.positionsMap[id]]);
            };
        }
    },
    mutations: {
        positions(state, positions) {
            state.positions = positions;
        },

        positionsMap(state, map) {
            state.positionsMap = map;
        },

        itemPositionsMap(state, map) {
            state.itemPositionsMap = map;
        },

        clear(state) {
            state.positions = [];
            state.itemPositionsMap = {};
            state.positionsMap = {};
        }
    },
    actions: {
        load({ state, commit }, params) {
            const position = state.positions[state.positionsMap[params.position_id]];
            return new Promise((resolve) => {
                axios.get('/history/position', { params })
                    .then((response) => {
                        if (response.data?.position) {
                            Object.assign(position, response.data.position);
                        }
                        position.loaded = true;
                        return resolve(position);
                    });
            });
        },
    },
}
